import React, { useState, useEffect } from 'react';
import { Grid, FormControlLabel, Switch, TextField, Typography } from '@mui/material';

const ThirdPartyAuthOptions = ({ formData, handleNestedChange, tempTheme }) => {
  const [newVals, setNewVals] = useState(formData.thirdPartyAuth);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleDebouncedChange = debounce((name, value) => {
    setNewVals((prevVals) => ({
      ...prevVals,
      [name]: value,
    }));
  }, 3000);

  const handleInputChange = (event) => {
    const { name, type, checked, value } = event.target;
    const inputValue = type === 'checkbox' ? checked : value;
    handleNestedChange('thirdPartyAuth', name, inputValue);
    handleDebouncedChange(name, inputValue);
  };

  // useEffect(() => {
  //   console.log('New Values:', newVals);
  // }, [newVals]);

  return (
    <>
      <Typography
        variant="h6"
        sx={{ marginTop: 4 }}
      >
        Third-Party Authentication Options
      </Typography>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.thirdPartyAuth.virginPulseLogin}
                name="virginPulseLogin"
                onChange={handleInputChange}
                sx={tempTheme}
              />
            }
            label="Activate Personify Health Login"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.thirdPartyAuth.epicLogin}
                name="epicLogin"
                onChange={handleInputChange}
                sx={tempTheme}
              />
            }
            label="Activate Epic Login"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextField
            fullWidth
            label="Cerbo Provider ID for Integration"
            name="cerboProviderID"
            value={formData.thirdPartyAuth.cerboProviderID}
            onChange={handleInputChange}
            sx={tempTheme}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ThirdPartyAuthOptions;
